import { render, staticRenderFns } from "./JSONFieldMapper.vue?vue&type=template&id=3220343a&"
import script from "./JSONFieldMapper.vue?vue&type=script&lang=js&"
export * from "./JSONFieldMapper.vue?vue&type=script&lang=js&"
import style0 from "./JSONFieldMapper.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports